import * as React from "react";
import * as ReactDOM from "react-dom";
import * as styles from "./styles.scss";
import * as stylesParent from "../../styles.scss";
import { Icon, Html } from "../../../../components";
import { themeVariables } from "../../../../entryes/panel/MUI";
import { tl } from "../../../../utils";
import { Dialog } from "@material-ui/core";
import { Close } from "@material-ui/icons";

const imgRegexp = /\.(png|gif|jpeg|jpg|bmp)$/i;

interface ICheckboxProps {
  value: any;
}

const downloadFile = (src: string) => {
  window.open(src);
};

export const File = ({ value }: ICheckboxProps) => {
  const [zoom, setZoom] = React.useState(null);
  
  if (value.length === 0) {
    return (
      <div>
        <span className={stylesParent.answerTitle}>Не был дан ответ</span>
        <div>
          <b>Пропущен!</b>
        </div>
      </div>
    );
  }

  return (
    <div className={stylesParent.answerBlock}>
      <div className={stylesParent.answerTitle}>{tl('Ответ.')}</div>
      {value.map((props: any, i: number) =>
        props.src ? (
          imgRegexp.test(props.src) ?  (
            <img key={i} style={{cursor: 'zoom-in'}} src={props.src} onClick={() => setZoom(props.src)} alt="img" />
          ) :
          props.fileScript ? (
              <Html key={i}>{props.fileScript}</Html>
          ) : (
          <div
            className={styles.file}
            key={i}
            onClick={() => downloadFile(props.src)}
          >
            <div
              className={styles.icon}
              style={{
                backgroundColor: themeVariables.palette.primary.light,
              }}
            >
              <Icon name={"document"} color="white" size={20} />
            </div>
            <div className={styles.filename}>
              {
                decodeURI(props.src)
                  .split("/")
                  .reverse()[0]
              }
            </div>
          </div>
          )
        ) : props.srcOriginal ? (
          <a href={props.srcOriginal} target="_blank">
            {
              `${tl('Скачать файл')} ${
                decodeURI(props.srcOriginal)
                  .split("/")
                  .reverse()[0]
              }`
            }
          </a>
        ) : (
          <div>{tl("Файл не найден.")}</div>
        )
      )}
      <Dialog
        open={!!zoom}
        onClose={() => setZoom(null)}
        maxWidth="lg"
      >
        <img src={zoom}/>
        <Close onClick={() => setZoom(null)}  style={{height: 24, fontSize: 24, color: '#fff', cursor: 'pointer', position: 'absolute', right: 20, top: 20}} />
      </Dialog>
    </div>
  );
};
